import React, { useState, useEffect } from 'react'
import './individualhouse.css'
import { useLocation } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ShowerOutlinedIcon from '@mui/icons-material/ShowerOutlined';
import BedOutlinedIcon from '@mui/icons-material/BedOutlined';
import { db } from '../firebase';
import {doc, getDoc} from 'firebase/firestore';
import { useRef } from 'react';
import emailjs from 'emailjs-com';
import { motion } from "framer-motion"




export default function IndividualHouse() {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  

  const [houses, setHouses] = useState([]);
    
     const useCurrentPath = () => {
      const location = useLocation();
      return location.pathname;
  };
  const currentPath = useCurrentPath();
    const newId = currentPath.split('/')[2];

  const templateId = "template_effkadf";
  const serviceId = "service_s2ns9bo";
  const userId = "jBCmCb2eQDUsz4MGn";

    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const currentUrl = window.location.href;
    const housename = houses.name + ' ' + currentUrl;
    console.log(housename)
    const form = useRef();

   
  

    useEffect(() => {
      const docRef = doc(db, "houses", newId);
      getDoc(docRef)
        .then((doc) => {
          if (doc.exists()) {
            setHouses({ id: doc.id, ...doc.data() });
          } else {
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    }, [newId]);






  const [selectedIndex, setSelectedIndex] = useState(0);

const handleNextClick = () => {
  document.querySelector('.mainimage').style.display = 'none';
  if (selectedIndex < houses.images.length - 1) {
    setMainImage(houses.images[selectedIndex + 1]);
    setSelectedIndex(selectedIndex + 1);
  }
};
 const handlePrevClick = () => {
  document.querySelector('.mainimage').style.display = 'none';
  if (selectedIndex > 0) {
    setMainImage(houses.images[selectedIndex - 1]);
    setSelectedIndex(selectedIndex - 1);
  }
};


const handleFormSubmit = (e) => {
  e.preventDefault();
  emailjs.sendForm(
    serviceId,
    templateId,
    form.current,
    userId
  ).then((result) => {
document.querySelector('.snackbar').style.display = 'block';
setTimeout(() => {
  document.querySelector('.snackbar').style.display = 'none';
}, 2000);
// clear form
setName('');
setPhone('');
setEmail('');
setMessage('');

  }
  ).catch((error) => {
    console.log(error.text);
  }
  );
  
}

const [mainImage, setMainImage] = useState(houses.imageUrl);



const handleMainImageChange = (e) => {
  e.preventDefault();
  setMainImage(e.target.value);
};



function handleThumbnailClick(index, imageUrl) {
  
  document.querySelector('.mainimage').style.display = 'none';
  setSelectedIndex(index);
  setMainImage(imageUrl);
}


return(
    <div className="house-details">
        <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 1 }}
    >
{

  houses ? (
    <div>
            
    <div className="title_rent">
    <div className="housetitle">
    <h2>{houses.name}</h2></div>
    <div className="renting">
      <p>Renting at KES {houses.price}</p>
    </div>
</div>
    <div className="houselocation">
    <LocationOnIcon className='locationicon'/>
    <h3> {houses.address}</h3>
    </div>
    <div className="housewrapper">
        <div className="image-slider">

<div className="imageswrapper">
  
<div className="sliders">
<img src={mainImage} alt=""
onChange={handleMainImageChange}
/>
        <img src={houses.imageUrl} alt=""
        onChange={handleMainImageChange}
        className="mainimage"
         />
        <ArrowBackIosNewIcon onClick={handlePrevClick} className="btn1" />
        <ArrowForwardIosIcon onClick={handleNextClick} className="btn2" />
      </div>
      <div className="thumbnail-container">
        <img
          src={houses.imageUrl}
          alt="Thumbnail"
          key={0}
          onClick={() => handleThumbnailClick(0, houses.imageUrl)}
          className={0 === selectedIndex ? 'selected' : ''}
        />
        {houses.images &&
          houses.images.map((image, index) => (
            <img
              src={image}
              alt="Thumbnail"
              key={index}
              onClick={() => handleThumbnailClick(index, image)}
              className={index === selectedIndex ? 'selected' : ''}
              
            />
          ))}
</div>

</div>

<div className="mobiletitle">
<div className="title_rent1">
    <div className="housetitle1">
    <h2>{houses.name}</h2></div>
    <div className="renting1">
      <p>Renting at KES{houses.price}</p>
    </div>
</div>
</div>

<div className="otheroverview">
<div className="overview">
<h2>Overview</h2>
<hr />
<div className="placement">
<p style={{marginRight: "10px", fontSize: "20px"}}>Bedrooms</p>
<div className="rooms">
<BedOutlinedIcon  className='roomicon'/> <div className="space2"></div> <p>{houses.bedrooms}</p> <div className="space"></div>
</div>
</div>
<div className="placement">
<p style={{marginRight: "10px", fontSize: "20px"}}>Bathrooms</p> 
<div className="rooms">
<ShowerOutlinedIcon className='roomicon'/><div className="space2"></div> <p>{houses.bathrooms}</p>
</div>
</div>
</div>
</div>

<div className="desc">
<div className="descdetails">
<h2>Description</h2>
<hr />
<div>
{houses && houses.description && houses.description.replace(/📌|🔹/g, (match) => `\n${match}`).split('\n').map((line, index) => (
  <div className='descdetails1' key={index}>{line}</div>
))}
</div>


</div>
</div>
</div>

<div className="contactonhouse">

<form ref={form} onSubmit={handleFormSubmit}>
  <input type="hidden" name="housename" value={housename} />
<label>
Name:
<input
  type="text"
  name="name"
  placeholder="Enter your name"
  value={name}
  required
  onChange={(e) => {setName(e.target.value)}}
/>
</label>
<br />
<label>
Phone:
<input
  type="text"
  name="phone"
  placeholder="Enter your phone number"
  value={phone}
  required
  onChange={(e) => {setPhone(e.target.value)}}
/>
</label>
<br />
<label>
Email:
<input
  type="email"
  name="email"
  placeholder="Enter your email"
  value={email}
  required
  onChange={(e) => {setEmail(e.target.value)}}
/>
</label>
<br />
<label>
Message:
<textarea
  name="message"
  placeholder="Enter your message"
  value={message}
  required
  onChange={(e) => {setMessage(e.target.value)}}
/>
</label>
<br />
<button type="submit">Send</button>
<div className="snackbar"
  style={{ display: 'none',
  opacity: '0.5',
   }}
>
  <p>Message sent successfully</p>
</div>
</form>
</div>
</div>
        </div>
  ) : (
    <div>
      <h1>
        Loading...
      </h1>
      </div>
  )

  
}


</motion.div>
  </div>
)

}
